/** Line weight shared by the carousel chevrons (viewBox units; 24-unit box). */
export const CHEVRON_STROKE_WIDTH = 1.5;
